import { STATE_ID_ONBOARDING, SUBFLOW_ID_PREFIX, STATE_ID_END } from './services/BuilderStateService';
export const CURRENT_SUBFLOW_VERSION = 2;
const CUSTOM_ACTION_REDIRECT_TYPE = 'Redirect';
export class BuilderMigrateFlows {
    migrate(application, flow) {
        if (application.isSubflow && this.getCurrentFlowVersion(application) < CURRENT_SUBFLOW_VERSION) {
            this.updateSubflowToVersion2(flow);
        }
        else if (!application.isSubflow) {
            this.updateFlowToSubflowVersion2(flow);
        }
    }
    updateSubflowToVersion2(flow) {
        for (const key in flow) {
            if (key === STATE_ID_END || key === STATE_ID_ONBOARDING) {
                const state = flow[key];
                if (state.id === STATE_ID_END) {
                    state.end = true;
                    state.$enteringCustomActions = [];
                }
                if (state.id == STATE_ID_ONBOARDING) {
                    state.$contentActions.forEach((item) => {
                        if (item.input) {
                            item.input.bypass = true;
                        }
                    });
                }
            }
        }
    }
    updateFlowToSubflowVersion2(flow) {
        for (const key in flow) {
            if (this.isSubflowId(flow[key].id)) {
                const state = flow[key];
                const redirectIndex = state.$enteringCustomActions.findIndex((item) => item.type === CUSTOM_ACTION_REDIRECT_TYPE);
                if (redirectIndex >= 0) {
                    state.$enteringCustomActions.splice(state.$enteringCustomActions.findIndex((item) => item.type === CUSTOM_ACTION_REDIRECT_TYPE), 1);
                }
            }
        }
    }
    isSubflowId(stateId) {
        return stateId.startsWith(SUBFLOW_ID_PREFIX);
    }
    getCurrentFlowVersion(application) {
        return application.applicationJson.settings.flow.version ?? 1;
    }
}
